(function() {
    'use strict';

    angular
        .module('gwApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };
        var DateZoneOffset_Value = ( - new Date().getTimezoneOffset() / 60);

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            config.headers["DateZone-Offset"] = DateZoneOffset_Value;
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();
